module.exports = {
    isAuthenticated: () => localStorage.getItem('token') != null
}